import React from "react";
import { cn } from "../../../utils";

const Separator: React.FC<{
	style?:
		| "none"
		| "solid"
		| "dashed"
		| "dotted"
		| "double"
		| "grove"
		| "inset"
		| "outset"
		| "ridge";
	showOn?: "always" | "hover";
}> = ({ style, showOn = "always" }) => {
	if (!style || "none" === style) return null;
	return <div className={cn("separator", `${style}`, `${showOn}`)} />;
};

export default Separator;
